import React, { useEffect, useState } from 'react';

import { Box } from '@mantine/core';

// Pops in on mount — used with `key={status}` to animate each state change.
const PopIn = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(true);
  }, []);
  return (
    <Box
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'scale(1)' : 'scale(0.6)',
        transition: 'opacity 180ms ease, transform 180ms ease',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
};

export default PopIn;
